import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


import { ConfigServerService, CustomHttp } from '../../../../../core';
import { PedidoIntegracaoImportFilter } from '../../pedido-integracao-import-filter';

@Injectable({
    providedIn: 'root'
})
export class PedidoIntegracaoEcommerceImportHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApiIntegrationEcommerce()}/pedido`;
    }

    import(filter: PedidoIntegracaoImportFilter): Observable<any> {
        return this.customHttp.post<any>(this.pathApi, filter);
    }

    importOne(idIntegracaoEcommerce: number, numeroEcommerce: string): Observable<any> {
        const filter = new PedidoIntegracaoImportFilter();
        filter.idIntegracao = idIntegracaoEcommerce;
        filter.numeroPedidoIntegracao = numeroEcommerce;
        return this.customHttp.post<any>(this.pathApi, filter);
    }
}
